// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d18b179","455":"e70835c0","977":"22f66a2b"}[chunkId] + ".chunk.js";
};